/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { notificationControllerCountV1 } from '../fn/notification/notification-controller-count-v-1';
import { NotificationControllerCountV1$Params } from '../fn/notification/notification-controller-count-v-1';
import { notificationControllerFindByIdV1 } from '../fn/notification/notification-controller-find-by-id-v-1';
import { NotificationControllerFindByIdV1$Params } from '../fn/notification/notification-controller-find-by-id-v-1';
import { notificationControllerSearchV1 } from '../fn/notification/notification-controller-search-v-1';
import { NotificationControllerSearchV1$Params } from '../fn/notification/notification-controller-search-v-1';
import { notificationControllerSendNotificationParentV1 } from '../fn/notification/notification-controller-send-notification-parent-v-1';
import { NotificationControllerSendNotificationParentV1$Params } from '../fn/notification/notification-controller-send-notification-parent-v-1';
import { notificationControllerSendNotificationTeacherV1 } from '../fn/notification/notification-controller-send-notification-teacher-v-1';
import { NotificationControllerSendNotificationTeacherV1$Params } from '../fn/notification/notification-controller-send-notification-teacher-v-1';
import { NotificationDto } from '../models/notification-dto';
import { NotificationSearchResponseDto } from '../models/notification-search-response-dto';

@Injectable({ providedIn: 'root' })
export class NotificationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `notificationControllerSendNotificationTeacherV1()` */
  static readonly NotificationControllerSendNotificationTeacherV1Path = '/api/v1/notification/send/teacher';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationControllerSendNotificationTeacherV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerSendNotificationTeacherV1$Response(params?: NotificationControllerSendNotificationTeacherV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return notificationControllerSendNotificationTeacherV1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationControllerSendNotificationTeacherV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerSendNotificationTeacherV1(params?: NotificationControllerSendNotificationTeacherV1$Params, context?: HttpContext): Observable<void> {
    return this.notificationControllerSendNotificationTeacherV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `notificationControllerSendNotificationParentV1()` */
  static readonly NotificationControllerSendNotificationParentV1Path = '/api/v1/notification/send/parent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationControllerSendNotificationParentV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerSendNotificationParentV1$Response(params?: NotificationControllerSendNotificationParentV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return notificationControllerSendNotificationParentV1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationControllerSendNotificationParentV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerSendNotificationParentV1(params?: NotificationControllerSendNotificationParentV1$Params, context?: HttpContext): Observable<void> {
    return this.notificationControllerSendNotificationParentV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `notificationControllerCountV1()` */
  static readonly NotificationControllerCountV1Path = '/api/v1/notification/count';

  /**
   * 읽지 않은 알람 개수 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationControllerCountV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerCountV1$Response(params: NotificationControllerCountV1$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return notificationControllerCountV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 읽지 않은 알람 개수 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationControllerCountV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerCountV1(params: NotificationControllerCountV1$Params, context?: HttpContext): Observable<number> {
    return this.notificationControllerCountV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `notificationControllerSearchV1()` */
  static readonly NotificationControllerSearchV1Path = '/api/v1/notification/search';

  /**
   * 알림 검색.
   *
   * 회원이 검색할 경우 내 알림을 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerSearchV1$Response(params: NotificationControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationSearchResponseDto>> {
    return notificationControllerSearchV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 알림 검색.
   *
   * 회원이 검색할 경우 내 알림을 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerSearchV1(params: NotificationControllerSearchV1$Params, context?: HttpContext): Observable<NotificationSearchResponseDto> {
    return this.notificationControllerSearchV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationSearchResponseDto>): NotificationSearchResponseDto => r.body)
    );
  }

  /** Path part for operation `notificationControllerFindByIdV1()` */
  static readonly NotificationControllerFindByIdV1Path = '/api/v1/notification/{id}';

  /**
   * 알림 읽기.
   *
   * 회원이 알림을 읽습니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerFindByIdV1$Response(params: NotificationControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationDto>> {
    return notificationControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 알림 읽기.
   *
   * 회원이 알림을 읽습니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerFindByIdV1(params: NotificationControllerFindByIdV1$Params, context?: HttpContext): Observable<NotificationDto> {
    return this.notificationControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationDto>): NotificationDto => r.body)
    );
  }

}
